export default __webpack_public_path__ + "static/media/fad-logo-waveform.42a088c3.svg";